export default "__VITE_ASSET__oYDK5WpL__"